import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import styles from './HeaderPanel.module.css';
import type AssistantViewController from '../AssistantView/AssistantViewController';
import classNames from 'classnames';
import HeaderButtons from './HeaderButtons';
import creditIconSvg from '../../assets/icons/credit.svg';

const HeaderPanel = () => {
  const controller = useController<AssistantViewController>();
  const { size, readOnly } = controller.state;
  const isFullPage = size === 'full-page';
  const isFullScreen = ['full-screen', 'full-page'].includes(size);

  return (
    <div
      className={classNames(styles.header, {
        [styles.fullScreen]: isFullScreen,
      })}
    >
      <span className={styles.headerTitle}>
        <aha-ai-icon />
        <span className={styles.assistantName}>AI assistant</span>
        {controller.state.model.currentChat.id && (
          <span className={styles.headerAgentName}>
            {controller.agent.publicName()}
          </span>
        )}
      </span>
      {!isFullPage && !readOnly && <HeaderButtons />}
      {readOnly && controller.props.creditCost && (
        <>
          <aha-button
            kind='plain'
            size='mini'
            style={{
              height: '19px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <img src={creditIconSvg} /> AI credits{' '}
              {controller.props.creditCost}
            </div>
          </aha-button>
        </>
      )}
    </div>
  );
};

export default ApplicationView(HeaderPanel);
